// PRODUCTION — Formik-bound text field
import React from 'react'
import tw from 'twin.macro'
import { useFormikContext } from 'formik'
import { flowEditorTextInputSmCss } from '../../flowEditorInputStyles'

export interface ProtoTextFieldProps<T> {
  name: keyof T & string
  placeholder?: string
  disabled?: boolean
}

export const ProtoTextField = <T extends object>({
  name,
  placeholder,
  disabled = false,
}: ProtoTextFieldProps<T>) => {
  const { values, setFieldValue } = useFormikContext<T>()
  const value = values[name] as unknown as string

  return (
    <input
      type="text"
      value={value ?? ''}
      placeholder={placeholder}
      readOnly={disabled}
      onChange={(e) => {
        if (!disabled) {
          setFieldValue(name, e.target.value)
        }
      }}
      css={[
        flowEditorTextInputSmCss,
        disabled
          ? tw`cursor-not-allowed bg-shades-50 text-shades-500 opacity-[0.85]`
          : tw`cursor-text text-shades-900`,
      ]}
    />
  )
}
